import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, Component, Input, OnDestroy, signal
} from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Player que carrega o áudio sob demanda por um `carregar()` (GET autenticado que
 * retorna Blob). Cria o objectURL só no primeiro play e o revoga ao destruir.
 */
@Component({
  selector: 'app-audio-player',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div class="player">
      @if (url()) {
        <audio [src]="url()!" controls autoplay preload="metadata"></audio>
      } @else {
        <button type="button" class="player__btn"
                (click)="carregarEtocar()" [disabled]="carregando()">
          <i class="material-icons">{{ carregando() ? 'hourglass_empty' : 'play_arrow' }}</i>
          {{ carregando() ? 'Carregando…' : rotulo }}
          @if (duracaoSegundos) { <span class="player__dur">· {{ duracaoFormatada() }}</span> }
        </button>
      }
      @if (erro()) { <p class="player__erro">{{ erro() }}</p> }
    </div>
  `,
  styles: [`
    :host { display: block; }
    .player__btn {
      display: inline-flex; align-items: center; gap: .4rem;
      border: none; border-radius: 999px; cursor: pointer;
      font: inherit; font-weight: 600; font-size: .85rem; line-height: 1;
      padding: .5rem .9rem; background: rgba(99,102,241,.12); color: #4f46e5;
      transition: filter .15s ease;
    }
    .player__btn .material-icons { font-size: 1.15rem; }
    .player__btn:hover { filter: brightness(.96); }
    .player__btn:disabled { opacity: .6; cursor: default; }
    .player__dur { font-variant-numeric: tabular-nums; opacity: .8; margin-left: .25rem; }
    .player audio { height: 40px; max-width: 100%; }
    .player__erro { margin: .35rem 0 0; font-size: .82rem; color: #b91c1c; }
  `]
})
export class AudioPlayerComponent implements OnDestroy {
  @Input() rotulo = 'Ouvir áudio';
  @Input() duracaoSegundos?: number | null;
  @Input({ required: true }) carregar!: () => Observable<Blob>;

  readonly url = signal<string | null>(null);
  readonly carregando = signal(false);
  readonly erro = signal<string | null>(null);

  duracaoFormatada(): string {
    const s = this.duracaoSegundos ?? 0;
    return `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')}`;
  }

  carregarEtocar(): void {
    if (this.carregando()) return;
    this.carregando.set(true);
    this.erro.set(null);
    this.carregar().subscribe({
      next: blob => {
        this.url.set(URL.createObjectURL(blob));
        this.carregando.set(false);
      },
      error: () => {
        this.erro.set('Não foi possível carregar o áudio.');
        this.carregando.set(false);
      }
    });
  }

  ngOnDestroy(): void {
    const u = this.url();
    if (u) URL.revokeObjectURL(u);
  }
}
